import getApiVersion from './actions/getApiVersion';

const actions = {
    getApiVersion
};

export default { actions };
